import * as ACT from '../actions/dashboardActions';

export function dashboard(state = {}, action) {
    switch (action.type) {


        case ACT.DASHBOARD_GET_ITEM:
            return {
                ...state,
                getItem: action.data,
            };
        case ACT.DASHBOARD_SET_ITEM:
            return {
                ...state,
                targetItem: action.data,
            };
        case ACT.DASHBOARD_GET_NOTE:
            return {
                ...state,
                getNote: action.data,
            };

        case ACT.DASHBOARD_FIELD_ERROR:
            if (state.fieldsError)
                var fieldsErrorPushed = state.fieldsError;
            else
                fieldsErrorPushed = {};
            fieldsErrorPushed[action.fieldName] = (action.fieldData != {}) ? action.fieldData : {err: true};


            return {
                ...state,
                fieldsError: fieldsErrorPushed,
                formError: true,
            };
        case ACT.DASHBOARD_FIELD_RESET_ERROR:
            return {
                ...state,
                fieldsError: {},
                formError: false,
            };


        default:
            return state
    }
};
